export const APP_NAME = 'F2X_PA';
export const DEFAULT_OTP_CODE_LENGTH = 6;
export const DEFAULT_OTP_TIMEOUT_IN_MS = 60000;
export const MFA_REQUIRED_RESPONSE_CODE = 'MULTI_FACTOR_REQUIRED';
export const MFA_EXPIRED_STATE_RESPONSE_CODE = 'MULTI_FACTOR_STATE_EXPIRED';
export const SIGNUP_STEPS = {
  EULA: 'eula',
  EMAIL: 'email',
  EMAIL_CONFIRMATION: 'email-confirmation',
  PHONE: 'phone',
  PHONE_CONFIRMATION: 'phone-confirmation',
  CREATE: 'create',
  FINISH: 'finish',
} as const;
export const VERIFICATION_REFETCH_INTERVAL = 10000; // 10 seconds
export const VERIFICATION_STEPS = {
  REGISTRATION: 'registration',
  EULA: 'eula',
  PROFILE: 'profile',
  QUESTIONARIES: 'questionaries',
  SUMSUB: 'sumsub',
  COMPLIANCE_CHECK: 'compliance_check',
  FINISH: 'finish',
} as const;
export const SUMSUB_VERIFICATION_STATUS = {
  INIT: 'init',
  PENDING: 'pending',
  PRECHECKED: 'prechecked',
  QUEUED: 'queued',
  ONHOLD: 'onHold',
  COMPLETED: 'completed',
} as const;
export const REGISTRATION_USER_TYPE_KEY = 'registrationUserType';
export const REGISTRATION_PERSONAL_STATE_KEY = 'registrationPersonalState';
export const REGISTRATION_CORPORATE_STATE_KEY = 'registrationCorporateState';
export const DEFAULT_UTM_HEADER = 'utm_source=web&utm_medium=organic';
export const UTM_COOKIE_NAME = 'f2x_utm';
export const UTM_DEFAULT_TTL_DAYS = 30;
export const VERIFICATION_SERVICES = {
  SUMSUB: 'sumsub',
  CYBERITY: 'cyberity',
} as const;
export const DEFAULT_BASE_ASSET = 'USDT';
export const DEFAULT_OPERATIONS_HISTORY_ITEMS_LIMIT = 10;
export const EXCHANGE_DISPLAYED_QUICK_SELECT_ITEMS_LIMIT = 4;
export const EXCHANGE_FILTERED_QUICK_SELECT_ITEMS_LIMIT = 20;
export const DEFAULT_RETRY_COUNT = 1;
export const INVOICE_FILE_TYPE = 'pdf';
export const COMMISSION_CHECK_DELAY = 2000;
export const REQUIRED_PLACEHOLDER_SYMBOL = '*';
export const DEFAULT_USER_FIRST_NAME = 'Jon';
export const DEFAULT_USER_LAST_NAME = 'Doe';
export const DEFAULT_DATE_PICKER_INPUT_YEAR = 1900;
export const DEFAULT_MIN_DATE = new Date(1900, 1, 1);
export const DEFAULT_DATE_RANGE_MIN_DATE = new Date(2020, 3, 1); // 1 April 2020
export const DATE_FILTERS = [
  'last24h',
  'last30d',
  'these3months',
  'thismonth',
  'prevmonth',
  '3mth',
  '6mth',
  '12mth',
] as const;
export const APP_SETTINGS_KEY = 'F2EX_APP_SETTINGS_STORE';
export const THEMES = ['light', 'dark'] as const;
export const REGISTRATION_STORE_KEY = 'F2EX_REGISTRATION_STORE';
// Brand
export const COMPANY = {
  name: 'FREE2EX',
};
// Emails
export const DEFAULT_SUPPORT_EMAIL = 'support@free2ex.com';
// Links
export const BUSINESS_ACCOUNT_PATH = 'https://live.free2ex.com/authentication';
export const WEBSITE_URL = 'https://free2ex.com/';
// Date Formats
export const OPERATION_HISTORY_DATE_FORMAT = 'ddMMyyyy';
export const DEFAULT_DATE_FORMAT = 'dd MMM yyyy';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const DATE_FORMAT_SHORT = 'dd.MM';
export const DATE_FORMAT_FULL = 'dd.MM.yyyy';
export const DATE_FORMAT_DAY_TIME = 'dd.MM HH:mm';
export const DATE_FORMAT_DAY_TIME_WITH_YEAR = 'dd.MM.yy HH:mm';
export const DATE_FORMAT_COMPACT = 'ddMMyyyy';
export const DATE_TIME_DISPLAY_FORMAT = 'MMM dd, yyyy, HH:mm';
export const OTC_DATE_TIME_FORMAT = 'MM/dd/yyyy HH:mm';
// Keys
export const OPERATIONS_HISTORY_KEY = 'operations-history';

export const PASSWORD_VALIDATION_REGEX = /^[^'"\s]+$/;
//export const PASSWORD_VALIDATION_REGEX =
//  /^[A-Za-zА-Яа-я0-9!@#$%^&*()_+\-=[\]{};:\\|,.<>/?`~]+$/;
export const PASSWORD_UPPER_VALIDATION_REGEX = /[A-ZА-Я]/;
export const PASSWORD_LOWER_VALIDATION_REGEX = /[a-zа-я]/;
export const PASSWORD_WITHOUT_RU_VALIDATION_REGEX =
  /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{};:\\|,.<>/?`~]+$/;
export const PASSWORD_WITHOUT_RU_UPPER_VALIDATION_REGEX = /[A-Z]/;
export const PASSWORD_WITHOUT_RU_LOWER_VALIDATION_REGEX = /[a-z]/;
export const HIDDEN_BALANCES_FULL_TEXT = '* ***,*';
